"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentScheduleModalCms = void 0;
var LegalDisclaimerModal_cms_1 = require("./LegalDisclaimerModal.cms");
var LegalatttvDisclaimerNewModalCms_cms_1 = require("./LegalatttvDisclaimerNewModalCms.cms");
var PaymentScheduleModalCms = /** @class */ (function () {
    function PaymentScheduleModalCms() {
        // tslint:disable-next-line:max-line-length
        this.dtvnModalTitle = 'AT&T TV Schedule of Future Payments';
        this.headingDescription = 'We\'ll charge all monthly payments to your payment method at 7 p.m.' +
            'ET on the dates shown below. Taxes and surcharges are extra.';
        this.discountPaymentThreeMonths = 'Discounted monthly payment (first [[total_months]] months)';
        this.discountPayments = 'Discounted monthly payment(s):';
        this.regularPayment = 'Regular payment (or the then-prevailing rate):';
        this.dtvnLinkLabel = 'See AT&T TV NOW Payment Schedule';
        this.atttvModalLable = '— see additional details below.*';
        this.atttvLinkLable = 'See additional details';
        this.monthlyAutoChargesLabel = 'Monthly auto-charges';
        this.prevailingRateLabel = '(or the then-prevailing rate)';
        this.scheduleFuturePayLinkLabel = 'See AT&T TV Schedule of Future Payments';
        this.schedulePayLinkLabel = 'See Payment Schedule';
        this.taxesAndFeesLable = '*Price higher after promo(s) end. Taxes and fees extra.';
        this.legalShortTextIPTV = "We'll auto charge your first monthly payment on [[startDate]].";
        this.nopromos1 = "Your first monthly payment of $[[monthlyPrice]], plus taxes & fees, will be auto charged when you activate service on your TV, or on [[startDate]],";
        this.nopromos = this.nopromos1 + "whichever comes first. You agree the card you provide below will be used for any amount due today and for future AT&T TV monthly payments.";
        this.firstMonthlyChargeNoPromos1 = "Your first monthly payment of $[[monthlyPrice]], plus taxes & fees, will be auto charged when you activate service on your TV,";
        this.firstMonthlyChargeNoPromos2 = this.firstMonthlyChargeNoPromos1 + "or on [[startDate]], whichever comes first. You agree the card you provide below will be used for any";
        this.firstMonthlyChargeNoPromos = this.firstMonthlyChargeNoPromos2 + " amount due today and for future AT&T TV monthly payments.";
        this.serviceRenewalTextNoPromos1 = "Your AT&T TV service will renew monthly at the then-prevailing rate, unless it's canceled. Prices are subject to change at any time.";
        this.serviceRenewalTextNoPromos2 = "To change or cancel service, call 800.288.2020 or go to att.com to manage your account or chat with an agent.";
        this.serviceRenewalTextNoPromos3 = " You will not receive a monthly bill. Account information";
        this.serviceRenewalTextNoPromos = "" + this.serviceRenewalTextNoPromos1 + this.serviceRenewalTextNoPromos2 + this.serviceRenewalTextNoPromos3 + " is available at att.com/myatt.";
        this.legalDisclaimer = new LegalDisclaimerModal_cms_1.LegalDisclaimerModalCMS();
        this.legalatttvDisclaimerNew = new LegalatttvDisclaimerNewModalCms_cms_1.LegalatttvDisclaimerNewModalCms();
    }
    return PaymentScheduleModalCms;
}());
exports.PaymentScheduleModalCms = PaymentScheduleModalCms;
//# sourceMappingURL=PaymentScheduleModalCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/PaymentDetailsPanel/PaymentScheduleModal/PaymentScheduleModalCms.cms.js
// module id = 2271
// module chunks = 8